import { useLocation, useNavigate } from "react-router-dom";

// Path-driven sibling of useUrlSyncedTab: the active tab lives in the URL path
// (`/payroll/structure`) instead of `?tab=`, so sidebar NavLinks can drive and
// highlight it (spec module-subpage-navs). The default tab owns the bare base
// path — its segment is "" — which is what keeps pre-existing bookmarks of the
// base URL rendering what they always rendered.
export function useRouteTab<T extends string>(
  base: string,
  segmentForTab: Record<T, string>,
  defaultTab: T,
): [T, (next: T) => void] {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const rest = pathname === base ? "" : pathname.startsWith(base + "/") ? pathname.slice(base.length + 1) : "";
  const entries = Object.entries(segmentForTab) as [T, string][];
  const match = entries.find(([, seg]) => seg === rest);
  const tab: T = match ? match[0] : defaultTab;

  function setTab(next: T) {
    const seg = segmentForTab[next];
    navigate(seg ? `${base}/${seg}` : base);
  }

  return [tab, setTab];
}
